
import React from "react";
import { motion } from "framer-motion";

export function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed bottom-0 left-0 right-0 bg-[#1a1a2e]/95 backdrop-blur-sm border-t border-[#ff3366]/20 py-4"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <div className="text-sm text-[#ff3366]/80">
            <p>Powered by <a href="https://tech4life.pro" target="_blank" rel="noopener noreferrer" className="hover:text-[#ff3366]">Tech4Life.pro</a></p>
          </div>
        </div>
      </div>
    </motion.footer>
  );
}
